import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus';
import dropzone from "./components/dropzone";
import Autosize from '@marcreichel/alpine-autosize';

window.Alpine = Alpine

Alpine.data('dropzone', dropzone)

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(Autosize);

Alpine.start()
